import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=checking, null=guest, object=auth

  useEffect(() => {
    if (!window.location.pathname.startsWith("/admin")) return setUser(null);
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(null));
  }, []);

  const login = useCallback(async (email, password, trap = {}) => {
    const { data } = await api.post("/auth/login", { email, password, ...trap });
    return data; // { requires_2fa, challenge_id, phone_hint, dev_code? }
  }, []);

  const verify2fa = useCallback(async (challenge_id, code) => {
    const { data } = await api.post("/auth/verify-2fa", { challenge_id, code });
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, verify2fa, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}
